module.exports = {"450923100":"博白镇","450923102":"双凤镇","450923105":"顿谷镇","450923106":"水鸣镇","450923107":"那林镇","450923108":"江宁镇","450923109":"三滩镇","450923110":"黄凌镇","450923111":"亚山镇","450923112":"旺茂镇","450923114":"东平镇","450923115":"沙河镇","450923116":"菱角镇","450923117":"新田镇","450923118":"凤山镇","450923119":"宁潭镇","450923120":"文地镇","450923121":"英桥镇","450923122":"那卜镇","450923123":"大垌镇","450923124":"沙陂镇","450923125":"双旺镇","450923126":"松旺镇","450923127":"龙潭镇","450923128":"大坝镇","450923129":"永安镇","450923130":"径口镇","450923131":"浪平镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450923.json
// module id = 2265
// module chunks = 0